import {Component, Input, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MapToolsService} from '../../services/map-tools.service';
import {PermissionsService} from '../../../common/service/permissions.service';

@Component({
    selector: 'nlr-move-annotation',
    imports: [CommonModule],
    templateUrl: './move-annotation.component.html',
    styleUrl: './move-annotation.component.scss'
})
export class MoveAnnotationComponent implements OnInit {
    @Input()
    disabled: boolean;

    title: string = 'MoveAnnotationComponent';

    permissions = ['EDIT_DESIGN', 'VIEW_DESIGN'];

    constructor(
        private mapToolsService: MapToolsService,
        private permissionsService: PermissionsService
    ) {}

    ngOnInit() {
        this.mapToolsService.init(
            'MOVE',
            () => {},
            () => {},
            () => this.isDisabled()
        );
    }

    getTooltip() {
        return this.mapToolsService.getTooltipWithShortcut('MOVE', 'Move annotation, call-outs and improvement features');
    }

    toggle() {
        this.mapToolsService.toggle('MOVE');
    }

    hasPermission() {
        return this.permissionsService.hasPermission(this.permissions);
    }

    isActive() {
        return !this.mapToolsService.isInactive('MOVE');
    }

    isDisabled() {
        return this.disabled || !this.permissionsService.hasEditPermission(this.permissions);
    }

    isSuspended() {
        return (
            this.mapToolsService.isSuspended('MOVE') &&
            (!this.mapToolsService.isActive('PAN') || this.mapToolsService.getActiveToolsThatSuspend('MOVE').length > 1)
        );
    }
}
